import { makeStyles, SpeedDial } from '@rneui/themed'
import { Image } from 'expo-image'
import React, { useState } from 'react'
import { ImageSourcePropType } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { getDarkShadeColor } from 'shared/utils'

export interface Item {
  name: string
  title: string
  icon?: string
  type?: string
  source?: ImageSourcePropType
}

interface Props {
  items?: Item[]
  icon?: string
  onPress?(): void
  onPressItem?(name: string): void
  marginRight?: number
  marginBottom?: number
  useBottomInset?: boolean
}

export function FloatingActionButton({
  items,
  icon,
  onPress,
  onPressItem,
  marginRight,
  marginBottom,
  useBottomInset = true,
}: Props) {
  const isSingleItem = !!icon || !!onPress
  const [isOpen, setIsOpen] = useState(false)
  const styles = useStyles()
  const { bottom } = useSafeAreaInsets()

  const handlePressMainButton = () => {
    if (isSingleItem) {
      onPress?.()
    } else {
      setIsOpen(!isOpen)
    }
  }

  return (
    <SpeedDial
      isOpen={isOpen}
      icon={{
        name: icon || 'plus',
        color: styles.item.color,
        type: 'font-awesome-5',
        solid: true,
      }}
      openIcon={{
        name: icon || 'times',
        color: styles.item.color,
        type: 'font-awesome-5',
        solid: true,
      }}
      onOpen={handlePressMainButton}
      overlayColor={isSingleItem ? 'transparent' : getDarkShadeColor(0.5)}
      onClose={() => setIsOpen(false)}
      buttonStyle={[
        {
          backgroundColor: styles.button.color,
        },
      ]}
      containerStyle={{
        marginBottom: (useBottomInset ? bottom : 0) + (marginBottom ?? 0),
        marginRight,
      }}
    >
      {items?.map(item => (
        <SpeedDial.Action
          key={item.name}
          title={item.title}
          onPress={() => {
            onPressItem?.(item.name)
            setIsOpen(false)
          }}
          icon={
            item.source ? (
              <Image
                style={styles.icon}
                source={item.source}
                contentFit="contain"
              />
            ) : (
              {
                name: item.icon || 'circle',
                color: styles.item.color,
                type: item.type ?? 'font-awesome-5',
                solid: true,
              }
            )
          }
          buttonStyle={styles.itemButton}
          style={styles.itemButtonContainer}
          iconContainerStyle={styles.itemButtonIconContainer}
        />
      ))}
    </SpeedDial>
  )
}

const useStyles = makeStyles(theme => ({
  button: {
    color: theme.colors?.primary,
  },
  icon: {
    height: 20,
    width: 32,
    tintColor: theme.colors.white,
  },
  item: {
    color: theme.colors?.white,
  },
  itemButton: {
    color: theme.colors.white,
    backgroundColor: theme.colors?.primary,
    height: 60,
    width: 60,
    borderRadius: 50,
    padding: 0,
    margin: 0,
  },
  itemButtonContainer: {
    marginRight: -10,
  },
  itemButtonIconContainer: {
    padding: 0,
    justifyContent: 'center',
  },
}))
